import { useTranslation } from "react-i18next";
import { Medal, User, Calendar } from "iconsax-react";
import { EmptyState } from "@/shared/components";
import { formatDateForDisplay } from "@/shared/utils";
import type { GovernmentAwardRecord } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  records: GovernmentAwardRecord[];
  hasNoGovernmentAwards?: boolean;
}

export default function GovernmentAwardsSection({ records, hasNoGovernmentAwards }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (records.length === 0) {
    if (hasNoGovernmentAwards) {
      return <p className="text-body-regular-md content-base-secondary">{t("personalSheet.noGovernmentAwardsDeclared")}</p>;
    }
    return <EmptyState noDataText={t("personalSheet.empty.governmentAwards")} noDataHint={t("personalSheet.empty.governmentAwardsHint")} compact />;
  }

  return (
    <div className="flex flex-col gap-6">
      {records.map(function renderRecord(record, index) {
        return (
          <div key={record.id} className="flex flex-col">
            <p className="text-label-md content-base-primary mb-3">
              {t("personalSheet.recordNumber", { number: index + 1 })}
            </p>
            <ProfileDataRow icon={Medal} label={t("personalSheet.fields.awardName")} value={record.award_name} />
            <ProfileDataRow icon={User} label={t("personalSheet.fields.issuedBy")} value={record.issued_by} />
            <ProfileDataRow
              icon={Calendar}
              label={t("personalSheet.fields.issuedDate")}
              value={formatDateForDisplay(record.issued_date)}
            />
          </div>
        );
      })}
    </div>
  );
}
